export default __webpack_public_path__ + "static/media/stackoverflow.6c7baca1.svg";